export const ICONE_PADRAO_SIDEBAR = 'app-window';

export function normalizarChave(v: string): string {
  return (v || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '')
    .trim();
}

const MAPA_ICONES_MODULOS: Record<string, string> = {
  [normalizarChave('empresas')]: 'building',
  [normalizarChave('relatorios')]: 'book-text',
  [normalizarChave('transacao')]: 'refresh-cw',
  [normalizarChave('transacoes')]: 'refresh-cw',
  [normalizarChave('med')]: 'refresh-cw',
};
export function resolverIconeModulo(
  modulo: { nome?: string; caminho_exibicao?: string } | any,
): string {
  const nomeKey = normalizarChave(modulo?.nome || '');
  const caminhoKey = normalizarChave(
    String(modulo?.caminho_exibicao || '').replace(/\//g, ''),
  );

  return (
    MAPA_ICONES_MODULOS[nomeKey] ||
    MAPA_ICONES_MODULOS[caminhoKey] ||
    ICONE_PADRAO_SIDEBAR
  );
}

export function resolverIconeDoItem(
  item: Pick<{ iconLight: string; iconDark: string }, 'iconLight' | 'iconDark'>,
  isDarkMode: boolean,
): string {
  return isDarkMode ? item.iconDark : item.iconLight;
}
